import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { getList } from "actions/reports/actions";
import moment from "moment";
import DailyFilters from "views/pages/reports/daily-range-filters";
// import Chart from "react-apexcharts";
// import getDates from "helpers/getDates";
import filterTypes from "data/filter-types";
import Spinner from "views/lib/components/Spinner";
import { Tabs, Tab } from "react-bootstrap";
import DailyRangeDeposits from "views/pages/reports/daily-range-deposits";
import DailyDepositsVSPayment from "views/pages/reports/daily-deposits-vs-payment";
import DailyBikeTransfer from "views/pages/reports/daily-bike-transfer";
import DailyRoad from "views/pages/reports/daily-road";
import DailyRegistered from "views/pages/reports/daily-registered";

class ReportsDaily extends React.Component {
  defaultStart = moment()
    .subtract(1, "months")
    .startOf("day")
    .valueOf();

  defaultEnd = moment()
    .endOf("day")
    .valueOf();

  constructor(props) {
    super(props);

    this.handleSearch = this.handleSearch.bind(this);
    this.handleLoad = this.handleLoad.bind(this);

    this.state = {
      filters: [{
        fieldName: "start",
        fieldValue: this.defaultStart,
        searchOperation: filterTypes.MORE.value
      }, {
        fieldName: "end",
        fieldValue: this.defaultEnd,
        searchOperation: filterTypes.LESS.value
      }],
      page: 0,
      size: moment(this.defaultEnd)
        .diff(moment(this.defaultStart), "days"),
      sort: "end,desc"
    };

    this.handleLoad();
  }

  handleSearch = (filters) => {
    this.setState({
      filters,
      page: 0,
    }, this.handleLoad);
  };

  handleLoad = () => {
    const {
      page,
      // size,
      sort,
      filters,
    } = this.state;
    if (filters.length === 2) {
      const size = moment(filters[1].fieldValue)
        .diff(moment(filters[0].fieldValue), "days");
      this.props.getList(page, size, sort, filters);
    }
  };

  render() {
    const {
      loading,
      list
    } = this.props;
    const { filters } = this.state;

    // start: 1598040000000
    // end: 1598126399000

    // bookingsCount: 230
    // cardAttachmentsCount: 72

    // depositAmount: 0
    // depositCount: 0

    // exitedBikes: 137
    // insertedBikes: 114
    // paymentAmount: "NaN"
    // paymentCount: 965
    // registeredUsersCount: 203
    // rideAmount: "NaN"
    // rideCount: 1409
    // usersWhoRoad: 755

    const groups = {
      deposits: {},
      depositsCounts: {},
      payments: {},
      depositVsPayment: {},
      transfers: {},
      roads: {},
      registered: {},
      rides: {}
    };
    if (list.content && Array.isArray(list.content)) {
      list.content
        .reverse()
        .forEach(item => {
          groups.deposits[item.start] = {
            // depositAmount: item.depositAmount,
            // depositCount: item.depositCount,
            depositIdram: item.depositIdram,
            depositIdramTerminal: item.depositIdramTerminal,
            depositPayWithTelcell: item.depositPayWithTelcell,
            depositFastshift: item.depositFastshift,
            depositTelcell: item.depositTelcell,
            card: parseInt(item.depositAmount
              - item.depositIdram
              - item.depositIdramTerminal
              - item.depositPayWithTelcell
              - item.depositFastshift
              - item.depositTelcell, 10),
          };
          groups.depositsCounts[item.start] = {
            depositAmount: parseInt(item.depositAmount, 10),
            depositCount: item.depositCount,
          };
          groups.payments[item.start] = {
            paymentAmount: parseInt(item.paymentAmount, 10),
            paymentCount: item.paymentCount,
          };
          groups.depositVsPayment[item.start] = {
            depositAmount: parseInt(item.depositAmount, 10),
            paymentAmount: parseInt(item.paymentAmount, 10),
          };

          groups.transfers[item.start] = {
            insertedBikes: item.insertedBikes,
            exitedBikes: item.exitedBikes
          };

          groups.roads[item.start] = {
            usersWhoRoad: item.usersWhoRoad,
            bookingsCount: item.bookingsCount
          };

          groups.rides[item.start] = {
            usersWhoRoad: item.usersWhoRoad,
            rideAmount: parseInt(item.rideAmount, 10),
            rideCount: item.rideCount,
          };

          groups.registered[item.start] = {
            registeredUsersCount: item.registeredUsersCount,
            cardAttachmentsCount: item.cardAttachmentsCount
          };
        });
    }

    return (
      <div className="position-relative w-100 p-2">
        {!loading || <Spinner/>}

        <div className="filters">
          <DailyFilters
            activeFilters={filters}
            totalCount={list.total_count || 0}
            handleSearch={this.handleSearch}
          />
        </div>

        <div>

          <Tabs
            defaultActiveKey="deposits"
            id="report-tabs"
            unmountOnExit={true}
          >
            <Tab eventKey="deposits" title="Deposits">
              <DailyRangeDeposits
                deposits={groups.deposits}
                depositsCounts={groups.depositsCounts}
                payments={groups.payments}
              />
            </Tab>
            <Tab eventKey="payments" title="Payments">
              <DailyDepositsVSPayment
                depositVsPayment={groups.depositVsPayment}
              />
            </Tab>
            <Tab eventKey="transfers" title="Transfers">
              <DailyBikeTransfer transfers={groups.transfers}/>
            </Tab>
            <Tab eventKey="roads" title="Roads">
              <DailyRoad
                roads={groups.roads}
                rides={groups.rides}
              />
            </Tab>
            <Tab eventKey="registered" title="Registered">
              <DailyRegistered registered={groups.registered}/>
            </Tab>
          </Tabs>

        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  loading: state.reports.loading,
  list: state.reports.list,
});

const mapStateToDispatch = dispatch => ({
  getList: bindActionCreators(getList, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(ReportsDaily);



// WEBPACK FOOTER //
// ./src/views/pages/reports/daily-range.js